const MAX_TIME = 30000;

const timeouts = new WeakMap();

const expirer = (callback, timeout = null) => {
	return new Promise(async (resolve, reject) => {
		timeouts.set(
			callback,
			setTimeout(() => reject(new Error("Expired")), timeout || MAX_TIME)
		);

		try {
			resolve(await callback());
		} catch (e) {
			reject(e);
		} finally {
			clearTimeout(timeouts.get(callback));
		}
	});
};

export { expirer };
